import { combineReducers } from 'redux';
import fetchReducer from '../fetchReducer';
import sidebar from '../Sidebar/reducer';

export default combineReducers({
  fetchedData: fetchReducer,
  sidebar
});



// WEBPACK FOOTER //
// ./src/components/App/reducer.js